import type { NotificationsFeatureConfig } from './type';

export const config: NotificationsFeatureConfig = {
    filterNotificationTypes: [
        'BALANCE_WD',
        'INCOMING_TRX',
        'OUTGOING_TRX',
        'CARDS',
        'MISC',
        'REG_924',
        'REG_AUTH',
        'REG_E_CHANNEL',
        'REG_CARDS',
        'INSTANT_PAYMENT',
        'REQUEST_TO_PAY',
    ],
};
